// const API_BASE_URL = 'https://api.justgiving.com'
const SERVICES_API_BASE_URL = 'https://api.blackbaud.services'

const DEFAULT_HEADERS = {
	accept: 'application/json'
}

const request = (path, { params, headers, method = 'GET', body } = {}) => {
	const url = new URL(`${SERVICES_API_BASE_URL}${path}`)

	if (params) {
		Object.entries(params).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				url.searchParams.set(key, value)
			}
		})
	}

	const fetchOptions = {
		method,
		headers: {
			...DEFAULT_HEADERS,
			...headers
		}
	}

	if (body !== undefined) {
		fetchOptions.headers['content-type'] = 'application/json'
		fetchOptions.body = JSON.stringify(body)
	}

	return fetch(url.toString(), fetchOptions).then(async response => {
		if (!response.ok) {
			throw new Error(`Request failed: ${response.status}`)
		}

		return response.json()
	})
}

export const fetchPage = (page, slug, options = {}) => {
	const endpoint = slug || Number.isNaN(Number(page)) ? 'page' : 'page/id'

	const fetchers = [
		request(`/v1/${endpoint}/${page}`).then(pageData => {
			if (!options.includeFitness) {
				return pageData
			}

			return fetchPageFitness(pageData, options.fitnessParams).then(fitness => ({
				...pageData,
				fitness
			}))
		}),
		options.includeTags ? fetchPageTags(page) : Promise.resolve(undefined)
	]

	return Promise.all(fetchers).then(([pageData, tags]) => ({
		...pageData,
		...tags
	}))
}

export const fetchPageTags = page => request(`/v1/page/tags/${page}`)

export const fetchPageFitness = (
	page,
	{ limit = 100, offset = 0, startDate, endDate } = {}
) => {
	const slug = typeof page === 'object' ? page.pageShortName : page
	const params = { limit, offset, start: startDate, end: endDate }

	return request(`/v1/fitness/page/${slug}`, { params }).then(res =>
		request(
			`/v1/justgiving/page/${slug}/fitnessTotal`,
			{ params: { startDate, endDate } }
		).then(data => ({
			...res,
			totalAmount: data.distance,
			totalAmountElevation: data.elevation,
			totalAmountTaken: data.duration
		}))
	)
}

export const formatNumber = ({
  amount,
  locale = "en-GB",
  notation = "standard",
  places = 0,
  style = "decimal",
  ...options
}) => {
    const config = {
        minimumFractionDigits: 0,
        maximumFractionDigits: Math.min(places, 20),
        notation,
        style,
        ...options
    }

  return Intl.NumberFormat(locale, config).format(amount);
};

export const formatCurrency = ({
  amount,
  currencyCode: currency,
  currencyDisplay = "symbol",
  locale: baseLocale,
  notation,
  places,
}) => {
  const locale = baseLocale || setLocaleFromCurrency(currency);
  const isWholeNumber = amount % 1 === 0;

  return formatNumber({
    amount,
    currency: currency ? currency.toUpperCase() : currencyCode(locale),
    currencyDisplay,
    locale,
    minimumFractionDigits: places && !isWholeNumber ? 2 : 0,
    maximumFractionDigits: places ? 2 : 0,
    notation,
    places,
    style: "currency",
  });
};